import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { changeOrderAndOrderBy, changeOrder, changeOrderBy } from '#action/shipment/shipments-paginated';
import { parseQueryState } from '#component/shipment/log/helper';
import UserLocalStorage from '#utils/user-local-storage';

const LS_ORDER_KEY = 'shipmentsDashboardOrder';
const LS_ORDER_BY_KEY = 'shipmentsDashboardOrderBy';

/**
 * Sync shipments order and order by with user-related local storage.
 */

const useShipmentsLocalStorageSorting = () => {
  const [renderCount, setRenderCount] = useState(0);
  const {
    order,
    orderBy
  } = useSelector(s => s.shipmentsPaginated, shallowEqual);
  const dispatch = useDispatch();
  const location = useLocation();
  const { search } = location;
  const queryState = parseQueryState(search);
  const urlOrder = queryState.order;
  const urlOrderBy = queryState.orderBy;

  useEffect(() => {
    if (renderCount === 0) {
      const storageOrder = UserLocalStorage.getData(LS_ORDER_KEY);
      const storageOrderBy = UserLocalStorage.getData(LS_ORDER_BY_KEY);

      const urlOrStorageOrder = urlOrder || storageOrder;
      const urlOrStorageOrderBy = urlOrderBy || storageOrderBy;

      const isOrdersDifferent = urlOrStorageOrder !== order;
      const isOrdersByDifferent = urlOrStorageOrderBy !== orderBy;

      if (urlOrStorageOrder && urlOrStorageOrderBy && isOrdersDifferent && isOrdersByDifferent) {
        dispatch(changeOrderAndOrderBy(urlOrStorageOrder, urlOrStorageOrderBy, { refetch: false }));
      } else if (urlOrStorageOrder && isOrdersDifferent) {
        dispatch(changeOrder(urlOrStorageOrder));
      } else if (urlOrStorageOrderBy && isOrdersByDifferent) {
        dispatch(changeOrderBy(urlOrStorageOrderBy));
      }
      setRenderCount(s => s + 1);
    } else {
      UserLocalStorage.setData(LS_ORDER_KEY, order);
      UserLocalStorage.setData(LS_ORDER_BY_KEY, orderBy);
      UserLocalStorage.save();
    }
  }, [dispatch, renderCount, order, orderBy, urlOrder, urlOrderBy]);
};

export default useShipmentsLocalStorageSorting;
